import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col } from "antd";

import AddressHeader from "../../components/address/addressHeader";
import AddressBaseForm from "../../components/address/addressBaseForm";

function Address() {
  const { pathname } = useLocation();
  const [edit, setEdit] = useState();
  useEffect(() => {
    setEdit(pathname.endsWith("edit"));
  }, [pathname]);

  return (
    <Row>
      <Col>
        <AddressHeader edit={edit} />
        <AddressBaseForm edit={edit} />
      </Col>
    </Row>
  );
}

export default Address;
